<div class="session-limits-alert-container">
	<div class="session-limits-alert-header">
		<img obgImageContent="responsible-gaming.time-out" />
		<h1
			class="session-limits-alert-header-text"
			[innerHTML]="'responsible-gaming.daily-session-limit.title' | translate"
		></h1>
	</div>

	<div class="session-limits-alert-content">
		<p
			class="session-limits-alert-content-strong"
			[innerHTML]="'responsible-gaming.daily-session-limit-notification.text-played' | translate: {
			sessionDurationHours: sessionDurationHours,
			sessionDurationMinutes: sessionDurationMinutes
		}"
		></p>
		<p
			[innerHTML]="'responsible-gaming.daily-session-limit-notification.text-remaining' | translate: {
			sessionDurationLeftMinutes: sessionDurationLeftMinutes
		}"
		></p>
	</div>
</div>
